import React from 'react';
import { Tooltip, styled, tooltipClasses } from '@mui/material';

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    disableInteractive
    enterDelay={500}
    classes={{ popper: className }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.primary.active,
    color: theme.palette.mode === 'dark' ? '#ffffff' : '#000000',
    fontSize: '12px',
    position:'relative',
    borderRadius: '4px',
    boxShadow: '0 0 8px rgba(0, 0, 0, 0.3)',
    padding: '4px 12px',
    maxWidth: 220,
    border: theme.palette.mode === 'dark'
      ? '1px solid rgba(255, 255, 255, 0.2)'
      : '1px solid #d3d3d3',
    fontFamily: 'Arial, sans-serif',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.mode === 'dark' ? '#424242' :theme.palette.primary.active,
  },
}));

export default CustomTooltip;
